export default __webpack_public_path__ + "static/media/iosappdevelopment.cfc0ca50.png";